<template>
  <basic-dialog v-model="dialog"
                :actionButtons="actionButtons"
                :loading="saving"
                :secondaryButtons="secondaryButtons"
                :title="surveyEnded ? $t('surveys.reopen_answering') : $t('surveys.edit_schedule')">

    <v-card-text class="scroll-content">
      <p v-if="surveyEnded" class="mt-4">{{ $t('surveys.reopen_answering_help') }}</p>
      <v-form ref="form">
        <v-row>
          <v-col cols="12">
            <v-date-picker v-model="dates" color="accent" full-width no-title range show-week></v-date-picker>
          </v-col>
          <v-col v-if="datesError" cols="12">
            <v-alert :value="!!datesError" dense text type="error">
              {{ datesError }}
            </v-alert>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col cols="12">
          <div class="ml-6 subtitle-2">
            <span>{{ $t('surveys.chosen_dates') }}:</span> {{ $formatDateNoTime(dates[0]) || '?' }} -
            {{ $formatDateNoTime(dates[1]) || '?' }}
          </div>

        </v-col>
      </v-row>

    </v-card-text>

  </basic-dialog>
</template>

<script>
import BasicDialog from "@/components/BasicDialog";
import surveyApi from "@/api/survey";
import dayjs from "dayjs";

export default {
  name: "EditScheduleDialog",
  components: {BasicDialog},
  props: ['surveyEnded'],
  data() {
    return {
      saving: false,
      dialog: false,
      dates: [],
      survey: {},
      datesError: false,
      actionButtons: {
        cancel: {
          click: this.close,
        },
        save: {
          click: this.save,
        }
      },
      secondaryButtons: {
        clear: {
          click: this.clearDates,
        }
      }
    }
  },
  methods: {
    open(dates, survey) {
      this.dialog = true;
      this.dates = [...dates];
      this.survey = {...survey};
    },
    async save() {
      this.saving = true;

      this.datesError = false;
      if (this.dates.length < 2) {
        this.datesError = this.$t('surveys.errors.dates_error');
        this.saving = false;
        return;
      }

      this.dates = this.dates.sort((a, b) => {
        return dayjs(a).toDate() - dayjs(b).toDate();
      });

      const survey = {...this.survey};
      survey.start = dayjs(this.dates[0]).set('hour', 0).set('minute', 0).set('second', 0).toISOString();
      survey.end = dayjs(this.dates[1]).set('hour', 23).set('minute', 59).set('second', 59).toISOString();

      try {
        const response = await surveyApi.updateSurvey(survey);
        this.$emit('survey-saved', response);
        this.dialog = false;
        this.$showSuccessNotification(this.$t('surveys.survey_saved'));
      } catch (error) {
        this.$handleApiError(error, this.$t('surveys.errors.save_error'));
      }
      this.$store.dispatch('reloadMenuCount');
      this.saving = false;
    },
    close() {
      this.dialog = false;
    },
    clearDates() {
      this.dates = [];
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.datesError = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-content {
  max-height: calc(100vh - 240px);
  overflow: auto;
}

@media screen and (min-width: 600px) {
  .scroll-content {
    max-height: calc(100vh - 300px);
    overflow: auto;
  }
}
</style>
